var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{staticClass:"filter-modal",attrs:{"name":"filter-modal","width":`350px`,"height":`500px`,"pivotY":0.5},on:{"before-close":_vm.handlerBeforeClose,"before-open":_vm.handlerBeforeOpen,"opened":_vm.handlerOpened}},[_c('div',[(_vm.component)?_c(_vm.component,{tag:"component"}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }